export const BRIDGE_CONTRACT_ADDRESS = (import.meta.env.VITE_BRIDGE_CONTRACT || '0x5312439e76C691A1040ecf14beC9D5780a19fA63') as `0x${string}`
export const W2USDT_ADDRESS = (import.meta.env.VITE_W2USDT_TOKEN || '0x4EB1f00B77a1C75F8597b581B21C90f713336A64') as `0x${string}`
export const BSC_USDT_ADDRESS = '0x55d398326f99059fF775485246999027B3197955' as `0x${string}`

// Wallets
export const TREASURY_WALLET_BSC = '0xcB749EB0E395E3950E65FAb38d31d32Fe279EDb9' as `0x${string}`
export const BRIDGE_WALLET_BSC = '0x679396c3D71909FEd1a398d696F676E6e537b4f8' as `0x${string}`

export const UNI2_CHAIN_ID = 111888
export const BSC_CHAIN_ID = 56

export const UNI2_EXPLORER = import.meta.env.VITE_UNI2_EXPLORER || 'https://wer2scan.com'
export const BSC_EXPLORER = import.meta.env.VITE_BSC_EXPLORER || 'https://bscscan.com'
